import { createSelector } from 'reselect';

import { IConfig } from './interfaces';
import { IState } from '../core/redux/interfaces';

export const getState = (state: IState): IConfig => state.config || {};

export const getIsLoading = createSelector(
  [getState],
  ({ isLoading }) => isLoading
);

export const getError = createSelector([getState], ({ error }) => error);

export const getConfigData = createSelector([getState], ({ data }) => data);

export const getIsReady = createSelector(
  [getState],
  ({ hasLoaded }) => hasLoaded
);
